import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import {
  AccountService,
  AlertService,
  CampaignProductService,
  CampaignService,
  CampaignTrackingService,
  CRMCampaignService,
  FunnelStepService,
  MerchantService,
  OrderOptionsReportService,
  ReportsConfigService,
  StorageService,
  UserService,
  CancelReasonCategoryService, LoaderService
} from "../_services";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgxSmartModalService } from "ngx-smart-modal";
import { ReportsAbstractV2Component } from "./reports-abstract-v2.component";
import { MultiOptions } from "../custom-multi-select/multi-select";
import { OrderOptionsFields, OrderOptionsFilters } from "./utils/constants";
import { cloneDeep } from "lodash";
import { ReportTypes } from "./models/reports";
import { downloadFromUrl } from "../_helpers";

@Component({
  moduleId: module.id.toString(),
  selector: "order-options-report",
  templateUrl: "./templates/mini-report.component.html",
  styleUrls: ["./styles/reports-v2.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class OrderOptionsReportComponent
  extends ReportsAbstractV2Component
  implements OnInit, AfterViewInit
{
  reportTitle = "Order Options Report";
  fields: MultiOptions = cloneDeep(OrderOptionsFields);
  filters: MultiOptions = cloneDeep(OrderOptionsFilters);
  reportType = ReportTypes.ORDER_OPTIONS;
  dropdownsLoading: boolean = false;
  showSavesOnly: boolean = true;
  enableSavesOnlyFilter: boolean = true;
  enableDetailedDownload: boolean = true;

  predefinedFields = [];
  commonReportsFields = [];
  summaryFields = [];

  // Fixed dimensions for this mini report
  selectedDimensions = [
    {
      model: "path_name",
      label: "Customer Stage",
      selected: true,
      disabled: false,
    },
    {
      model: "step_name",
      label: "Step Name",
      selected: true,
      disabled: false,
    },
    {
      model: "impressions",
      label: "Impressions",
      selected: true,
      disabled: false,
    },
    {
      model: "hold_saves",
      label: "Hold Saves",
      selected: true,
      disabled: false,
    },
    {
      model: "subscription_saves",
      label: "Subscription Saves",
      selected: true,
      disabled: false,
    },
    {
      model: "rma_saves",
      label: "RMA Saves",
      selected: true,
      disabled: false,
    },
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected alertService: AlertService,
    public reportsService: OrderOptionsReportService,
    protected campaignService: CampaignService,
    protected reportsConfigService: ReportsConfigService,
    protected trackingSourceService: CampaignTrackingService,
    protected userService: UserService,
    protected accountService: AccountService,
    protected campaignProductService: CampaignProductService,
    protected crmCampaignService: CRMCampaignService,
    protected storageService: StorageService,
    protected stepService: FunnelStepService,
    protected merchantService: MerchantService,
    protected modalService: NgxSmartModalService,
    protected cancelReasonCategoryService: CancelReasonCategoryService,
    protected loaderService: LoaderService
  ) {
    super(
      router,
      location,
      route,
      alertService,
      reportsService,
      campaignService,
      reportsConfigService,
      trackingSourceService,
      userService,
      accountService,
      campaignProductService,
      crmCampaignService,
      storageService,
      stepService,
      merchantService,
      modalService,
      cancelReasonCategoryService
    );

    this.updatePreSelectedDimensions([
      "path_name",
      "step_name",
      "impressions",
      "hold_saves",
      "subscription_saves",
      "rma_saves"
    ]);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    // No panel expansion needed for this mini report
  }

  // Override getSummary to do nothing since this report has no summary
  getSummary() {
    this.isSummaryLoading = false;
  }

  // Override getReport to skip summary fetching
  getReport(fetchSummary: boolean = false) {
    super.getReport(false);
  }

  onShowSavesOnlyChange() {
    this.isConfigChanged = true;
  }

  // Override getQueryForReport to add show_saves_only field when checkbox is checked
  getQueryForReport() {
    let query = super.getQueryForReport();
    if (this.showSavesOnly) {
      // Create a new array to avoid modifying selectedDimensionsList which is used for table rendering
      query.fields = [...query.fields, 'show_saves_only'];
    }
    return query;
  }

  downloadDetailedReport() {
    this.loaderService.show();
    let req = {
      ...this.getQueryForReport(),
      start_date_formatted: this.date.startDate.format("MMM Do, YYYY"),
      end_date_formatted: this.date.endDate.format("MMM Do, YYYY"),
    };
    // Add show_detailed only for the detailed download request
    req.fields = [...req.fields, 'show_detailed'];

    this.reportsService
      .getDownloadReportData(req)
      .subscribe(
        (data) => {
          downloadFromUrl(data.download_url);
          this.loaderService.hide();
        },
        (error) => {
          this.loaderService.hide();
          if (error.status === 404) {
            this.alertService.error("No reports to download");
          } else {
            this.alertService.error("An error occurred while downloading report");
          }
        }
      );
  }
}
